export const Ireland = {
    name: "Ireland",
    image: "/Ireland.jpg",
    overview: {
        title: "Why Bangladeshi Students Choose Ireland for Higher Studies?",
        descriptions: [
            "Bangladeshi students choose Ireland for its world-class education system, English-speaking environment, and excellent post-study work opportunities. The country offers high-quality universities with strong industry connections.",
            "Ireland's vibrant culture, friendly people, and growing tech industry make it an attractive destination for international students seeking quality education and career prospects in Europe."
        ],
    },
    highlights: [
        {
            icon: "fas fa-city",
            title: "Student-friendly cities",
            description: "Dublin ranks among the top student cities globally, known for its excellent universities and vibrant cultural scene."
        },
        {
            icon: "fas fa-briefcase",
            title: "Post-study work rights",
            description: "Ireland offers up to 2 years of post-study work opportunities through the Third Level Graduate Scheme."
        },
        {
            icon: "fas fa-graduation-cap",
            title: "Top universities",
            description: "Ireland has 8 universities in the QS World University Rankings, with Trinity College Dublin ranking in the top 100."
        },
        {
            icon: "fas fa-users",
            title: "Tech hub",
            description: "Ireland is home to major tech companies like Google, Facebook, and Apple, providing excellent career opportunities."
        }
    ],
    keyFacts: [
        { factNumber: "8", factLabel: "Universities" },
        { factNumber: "30,000", factLabel: "International Students in Ireland in 2024" },
        { factNumber: "20 Hours", factLabel: "Per week Part-time work permit" },
        { factNumber: "2 Years", factLabel: "Post-study work permit" }
    ],
    stats: {
        capital: "Dublin",
        poplulation: "5.1 million",
        economicGrowthRate: "3.5%",
        currency: "Euro (EUR)",
        language: "English",
        weather: [
            "Dublin: 11°C - 19°C",
            "Cork: 10°C - 18°C",
            "Galway: 10°C - 17°C",
            "Limerick: 10°C - 18°C"
        ]
    },
    requirements: [
        "Academic transcripts",
        "English proficiency test scores (IELTS, TOEFL, PTE)",
        "Statement of Purpose",
        "Letter of Recommendation",
        "Valid passport copy",
        "Proof of finances (Bank statements)",
        "Health insurance",
        "Garda clearance certificate"
    ],
    intake: {
        title: "Irish universities offer two main intakes:",
        intakes: [
            {
                name: "Autumn Intake",
                month: "Starts in September/October"
            },
            {
                name: "Spring Intake",
                month: "Starts in January/February (Limited programs)"
            }
        ]
    },
    programs: [
        {
            name: "Certificate",
            duration: "1 year"
        },
        {
            name: "Diploma",
            duration: "1-2 years"
        },
        {
            name: "Bachelor's Degree",
            duration: "3-4 years"
        },
        {
            name: "Master's Degree",
            duration: "1-2 years"
        },
        {
            name: "PhD",
            duration: "3-4 years"
        }
    ],
    popularPrograms: {
        title: "Ireland offers high-quality education with focus on technology and innovation. Popular programs for international students include:",
        programs: [
            "Computer Science",
            "Business Administration",
            "Engineering",
            "Medicine",
            "Pharmacy",
            "Data Science",
            "Finance",
            "International Relations",
            "Creative Arts"
        ]
    },
    costs: [
        {
            program: "Foundation/Pathway",
            local: "EUR 8,000 - 15,000",
            bdt: "8,80,000 – 16,50,000 BDT"
        },
        {
            program: "Undergraduate Courses",
            local: "EUR 10,000 - 25,000",
            bdt: "11,00,000 – 27,50,000 BDT"
        },
        {
            program: "Postgraduate Courses",
            local: "EUR 12,000 - 30,000",
            bdt: "13,20,000 – 33,00,000 BDT"
        },
        {
            program: "PhD Programs",
            local: "EUR 8,000 - 15,000",
            bdt: "8,80,000 – 16,50,000 BDT"
        }
    ],
    topCities: {
        title: "Ireland offers excellent education in several vibrant cities with rich culture and history. Key student cities include:",
        cities: [
            {
                name: "Dublin",
                description: "Capital city with top universities and vibrant tech scene"
            },
            {
                name: "Cork",
                description: "Second largest city with excellent university and research facilities"
            },
            {
                name: "Galway",
                description: "Cultural city with growing university presence and innovation focus"
            },
            {
                name: "Limerick",
                description: "University city with strong engineering and technology programs"
            },
            {
                name: "Waterford",
                description: "Historic city with focus on technology and business programs"
            },
            {
                name: "Maynooth",
                description: "University town with focus on humanities and social sciences"
            }
        ]
    },
    workOptions: {
        partTimeWork: "International students can work up to 20 hours per week during study periods and full-time during breaks. Students typically earn EUR 10-15 per hour. The work experience in Ireland's growing tech industry can be highly valuable.",
        postStudyWork: "The Third Level Graduate Scheme allows graduates to stay and work in Ireland for up to 2 years after graduation. This provides an excellent opportunity to gain work experience in Ireland's strong economy and potentially qualify for permanent residency."
    },
    faqs: [
        {
            question: "How do I apply for a student visa in Ireland?",
            answer: "To apply for a student visa, you need an acceptance letter from an Irish institution, proof of English proficiency, financial capacity (EUR 7,000 per year), health insurance, and a completed visa application form. The application is processed through the Irish Naturalisation and Immigration Service."
        },
        {
            question: "What are the English language requirements for studying in Ireland?",
            answer: "Most Irish institutions require IELTS (6.0-6.5), TOEFL (80-90), or PTE (50-65) scores. Some programs may require higher scores, especially for competitive programs."
        },
        {
            question: "Can I work while studying in Ireland?",
            answer: "Yes, international students can work up to 20 hours per week during study periods and full-time during breaks. The Third Level Graduate Scheme allows graduates to work after completing their studies."
        },
        {
            question: "Are scholarships available for international students in Ireland?",
            answer: "Yes, there are various scholarships offered by the Irish government, universities, and external organizations. These include the Government of Ireland Scholarships, university-specific scholarships, and EU/EEA mobility programs."
        },
        {
            question: "How much does it cost to study in Ireland from Bangladesh?",
            answer: "Studying in Ireland from Bangladesh costs around EUR 10,000-30,000 for tuition, EUR 800-1,200 per month for living expenses, and EUR 200-400 for health insurance annually. Total annual cost ranges from EUR 20,000-45,000."
        },
        {
            question: "What GPA is required to study in Ireland from Bangladesh?",
            answer: "To study in Ireland from Bangladesh, the required GPA typically ranges from <strong>3.0 to 3.5</strong> on a 4.0 scale for undergraduate programs and <strong>3.2 to 3.7</strong> for postgraduate programs, depending on the university and program competitiveness."
        }
    ]
}
